export const WELCOME_REQUEST = 'WELCOME_REQUEST'
export const WELCOME_SUCCESS = 'WELCOME_SUCCESS'
export const WELCOME_FAILURE = 'WELCOME_FAILURE'

export const FAQS_REQUEST = 'FAQS_REQUEST'
export const FAQS_SUCCESS = 'FAQS_SUCCESS'
export const FAQS_FAILURE = 'FAQS_FAILURE'

export const COMMON_REQUEST = 'COMMON_REQUEST'
export const COMMON_SUCCESS = 'COMMON_SUCCESS'
export const COMMON_FAILURE = 'COMMON_FAILURE'

export const CATEGORY_REQUEST = 'CATEGORY_REQUEST'
export const CATEGORY_SUCCESS = 'CATEGORY_SUCCESS'
export const CATEGORY_FAILURE = 'CATEGORY_FAILURE'

export const SEARCH_REQUEST = 'SEARCH_REQUEST'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILURE = 'SEARCH_FAILURE'
